import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Info = styled('p')`
  color: ${props => props.theme.palette.brand.gray1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: right;
`

export const Italic = styled('span')`
  font-style: italic;
`
